import * as React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import { ArrowRight } from '@abdt/icons';
import base from './base';
var tokens = createMuiTheme(base, {
    palette: {
        primary: {
            light: '#2471D3',
            main: '#2471D3',
            contrastText: '#fff',
        },
        secondary: {
            light: '#2471D3',
            main: '#2471D3',
            contrastText: '#fff',
        },
        text: {
            primary: '#202326',
            secondary: '#747E89',
        },
        divider: '#A4AEB8',
        background: {
            default: '#ffffff',
        },
        action: {
            active: '#5C646D',
        },
    },
});
var theme = createMuiTheme(tokens, {
    props: {
        Well: {
            size: 'large',
        },
        SimpleListItem: {
            sizes: {
                large: {
                    mb: 4,
                },
            },
        },
        MuiTextField: {
            size: 'small',
        },
        MuiRadio: {
            size: 'small',
        },
        MuiCheckbox: {
            size: 'small',
        },
        SimpleListIndicator: {
            isNumber: {
                small: {
                    mr: 2,
                },
                medium: {
                    mr: '10px',
                },
                large: {
                    mr: '14px',
                },
            },
        },
        MuiBreadcrumbs: {
            separator: React.createElement(ArrowRight, {
                color: '#9599a4',
                width: 16,
                height: 16,
            }),
        },
    },
    overrides: {
        // Tab
        MuiTab: {
            root: {
                fontSize: 14,
                lineHeight: '20px',
            },
        },
        // IconButton
        MuiIconButton: {
            root: {
                '&.Mui-focusVisible': {
                    boxShadow: "0 0 0 2px " + tokens.palette.primary.main,
                },
            },
        },
        // Accordion
        MuiAccordion: {
            root: {
                boxShadow: 'none',
                '&:before': {
                    display: 'none',
                },
                '&$expanded': {
                    margin: 'auto',
                },
                '&$disabled': {
                    backgroundColor: 'transparent',
                },
            },
            expanded: {},
        },
        MuiAccordionSummary: {
            root: {
                marginBottom: -1,
                minHeight: 'initial',
                '&$expanded': {
                    minHeight: 'initial',
                },
                '&$focused': {
                    backgroundColor: '#E1EAFF',
                },
            },
            content: {
                margin: 0,
                '&$expanded': {
                    margin: 0,
                },
            },
            expanded: {},
        },
        MuiOutlinedInput: {
            root: {
                '&$focused $notchedOutline': {
                    borderColor: tokens.palette.primary.main,
                },
            },
        },
        // Typography
        MuiTypography: {
            colorPrimary: {
                color: tokens.palette.text.primary,
            },
            colorSecondary: {
                color: tokens.palette.text.secondary,
            },
        },
        // Link
        MuiLink: {
            root: {
                color: tokens.palette.primary.main,
                cursor: 'pointer',
                '&:hover': {
                    color: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    color: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
        },
        // Container
        MuiContainer: {
            root: {
                maxWidth: 730,
            },
        },
        // Divider
        MuiDivider: {
            root: {
                backgroundColor: 'transparent',
                borderTop: "1px dotted " + tokens.palette.divider,
            },
        },
        // Checkbox
        MuiCheckbox: {
            root: {
                '&.Mui-focusVisible': {
                    '& .CheckBoxIcon': {
                        '&:after': {
                            boxShadow: "inset 0px 0px 0px 2px #E1EAFF",
                        },
                    },
                },
            },
        },
        // Radio
        MuiRadio: {
            root: {
                '&.Mui-focusVisible': {
                    '& .RadioIcon': {
                        '&:before': {
                            boxShadow: "inset 0px 0px 0px 2px #E1EAFF",
                        },
                    },
                },
            },
        },
        // Button
        MuiButton: {
            text: {
                color: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: '#ffffff',
                },
                '&:active': {
                    backgroundColor: '#ffffff',
                },
            },
            textPrimary: {
                color: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: '#ffffff',
                },
                '&:active': {
                    backgroundColor: '#ffffff',
                },
            },
            contained: {
                color: '#ffffff',
                backgroundColor: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
            containedPrimary: {
                color: tokens.palette.primary.contrastText,
                backgroundColor: tokens.palette.primary.main,
                '&:hover': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
                '&:active': {
                    backgroundColor: tokens.palette.primary.main,
                    opacity: '.9',
                },
            },
            containedSecondary: {
                color: '#1281D3',
                backgroundColor: '#F6FBFF',
                '&:hover': {
                    backgroundColor: '#F6FBFF',
                    opacity: '.9',
                },
                '&:active': {
                    backgroundColor: '#F6FBFF',
                    opacity: '.9',
                },
            },
            outlined: {
                color: tokens.palette.primary.main,
                border: "1px solid " + tokens.palette.primary.main,
                '&:hover': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&:active': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&.Mui-disabled': {
                    border: 'none',
                },
            },
            outlinedPrimary: {
                color: tokens.palette.primary.main,
                border: "1px solid " + tokens.palette.primary.main,
                '&:hover': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&:active': {
                    borderColor: tokens.palette.primary.main,
                    backgroundColor: 'transparent',
                    opacity: '.9',
                },
                '&.Mui-disabled': {
                    border: 'none',
                },
            },
        },
        // Tooltip
        MuiTooltip: {
            tooltip: {
                backgroundColor: '#fff',
                filter: 'drop-shadow(0px 8px 32px rgba(0, 0, 0, 0.08))',
                color: tokens.palette.text.primary,
            },
            arrow: {
                color: '#fff',
            },
        },
        // @ts-ignore
        // Calendar
        MuiPickersPopper: {
            root: {
                '&[x-placement="bottom"]': {
                    '& $paper': {
                        '&::before': {
                            borderBottom: "13px solid " + tokens.palette.secondary.light,
                        },
                    },
                },
            },
        },
        MuiPickersFadeTransition: {
            root: {
                '& > *': {
                    color: tokens.palette.primary.contrastText,
                },
            },
        },
        MuiPickersBasePicker: {
            pickerView: {
                backgroundColor: tokens.palette.secondary.light,
            },
        },
        MuiPickersDesktopDateRangeCalendar: {
            rangeCalendarContainer: {
                backgroundColor: tokens.palette.secondary.light,
            },
            arrowSwitcher: {
                '& [class*="MuiTypography-root"]': {
                    color: '#fff',
                },
            },
        },
        MuiPickersCalendarHeader: {
            monthText: {
                color: tokens.palette.primary.contrastText,
            },
            yearSelectionSwitcher: {
                color: tokens.palette.primary.contrastText,
            },
        },
        MuiPickersDateRangeDay: {
            rangeIntervalDayHighlight: {
                backgroundColor: 'rgba(0, 178, 169, 0.05)',
            },
            dayInsideRangeInterval: {
                color: tokens.palette.secondary.main,
            },
            dayOutsideRangeInterval: {
                '&:hover': {
                    border: 'none',
                },
            },
        },
        MuiPickersDay: {
            root: {
                color: tokens.palette.secondary.main,
                '&$selected': {
                    backgroundColor: tokens.palette.primary.main,
                    '&:hover, &:active, &:focus': {
                        backgroundColor: tokens.palette.primary.main,
                    },
                },
                '&:focus.Mui-selected.MuiButtonBase-root': {
                    backgroundColor: tokens.palette.primary.main,
                },
            },
            today: {
                color: tokens.palette.primary.main,
            },
        },
        MuiPickersYear: {
            yearButton: {
                color: tokens.palette.primary.contrastText,
            },
        },
        MuiPickersArrowSwitcher: {
            root: {
                '& button > span > svg': {
                    color: tokens.palette.primary.contrastText,
                },
                '& h6': {
                    color: tokens.palette.primary.contrastText,
                },
            },
        },
    },
});
export default theme;
//# sourceMappingURL=uslugirt.js.map